export default __webpack_public_path__ + "static/media/EasternPass.71686ece.jpg";